import React from "react";
import {Link} from "react-router-dom";

class BuySimSubNavi extends React.Component {
  render() {
    return (
        <section className="SubNavi">
          <div className="container mt-50">
            {/*<div className="row SubNavi-box">

            <div className="col-lg-4">
                <a className="SubNaviBtn btn btn-white text-center" href="/rent#RentSection">Rent MightyWifi</a>
            </div>
            <div className="col-lg-4">
              <a className="SubNaviBtn btn btn-white text-center" href="/buy/device#BuySection">Buy MightyWifi CLOUD</a>
            </div>
            <div className="col-lg-4" style={{ position:"relative" }}>
              <p className="icontag">Coming Soon</p>
              <a className="SubNaviBtn btn btn-white btn-disabled text-center" href="#">MightyWifi CLOUD PRO</a>
            </div>
            <!--<div className="col-lg-3" style={{ position:"relative" }}>
              <p className="icontag">Coming Soon</p>
              <a className="SubNaviBtn btn btn-white btn-disabled text-center" href="#">Buy MightyWifi CLOUD</a>
            </div>-->

            <div style={{ clear: "both", height: "70px" }} />


            <div className="col-lg-4">
              <a className="SubNaviBtn btn btn-white text-center" href="/recharge/device#RechargeSection">Buy Data</a>
            </div>
            <div className="col-lg-4">
              <a className="SubNaviBtn btn btn-white text-center" href="/activate#TopSection">Device Activation</a>
            </div>
            <div className="col-lg-4">
              <!--<a className="SubNaviBtn btn btn-white text-center btn-active" href="/get-sim#SimSection">SIM card</a>-->
              <a className="SubNaviBtn btn btn-white btn-disabled text-center" href="#">SIM card</a>
            </div>

            <div style={{ clear: "both", height: "100px" }} />
          </div>*/}
          </div>
        </section>
    );
  }
}

export default BuySimSubNavi;



// WEBPACK FOOTER //
// ./src/reusable/BuySimSubNavi.js